var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(_vm.to),expression:"to"}],tag:"component",staticClass:"anchor font-semibold u-clickable",attrs:{"type":_vm.type}},'component',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }